
import { Box, Stack, Typography } from '@mui/material';
import * as React from 'react';
import { useRef } from 'react';
import * as JSTool from '../store/JSTool';
import { settingActions, settingObj } from '../store/SettingSlice';
import { useSelector, useDispatch } from 'react-redux';
import $ from 'jquery';
import MobileMenu from '../component/MobileMenu';
import * as rdd from 'react-device-detect';
import LeftDownload from '../component/LeftDownload';
import RightBottom from '../component/RightBottom';
import { useParams, useLocation, useSearchParams } from 'react-router-dom';


import Page0 from './Page0';
import Page1 from './Page1';
import Page2 from './Page2';
import Page3 from './Page3';
import Page4 from './Page4';
import Footer from './Footer';


export default function DownloadPageMobile(props) {

    const dispatch = useDispatch();
    const settingData = useSelector(state => state.settingData);
    const [searchParams, setSearchParams] = useSearchParams();

    React.useEffect(() => {
        $("#home_page_view").on('scroll', () => {
            let x = $('#home_page_view').scrollTop();
            processScroll(x);
        });

        //平台
        const pt = searchParams.get('platform');
        if (!JSTool.isEmpty(pt)) {
            dispatch(settingActions.setPlatform(pt));
        }
    }, []);

    function processScroll(x) {
        //显示隐藏
        let h = settingData.innerHeight;
        if (x >= h - $("#nav_view").height()) {
            JSTool.setViewHidden(true);
        } else {
            JSTool.setViewHidden(false);
        }
    }

    function menuTap() {
        if (settingObj.showMenu) {
            JSTool.hideMenu();
        } else {
            JSTool.showMenu('menu_view');
        }
    }

    function logoTap() {
        window.location.href = window.location.origin;
    }

    return (
        <Stack
            sx={{
                width: 1,
                height: settingData.innerHeight,
                userSelect: 'none'
            }}>

            {/* 手机端导航栏 */}
            <Stack
                id='nav_view'
                sx={{
                    display: settingData.isMobile ? 'flex' : 'none',
                    width: 1,
                    height: rdd.isIPad13 ? '90px' : '60px',
                    bgcolor: '#000000ea',
                    flexDirection: 'row',
                    alignItems: 'center',
                    position: 'absolute',
                    zIndex: 3,
                }}>
                <Box
                    onClick={logoTap}
                    component={'img'}
                    src={JSTool.getImgPath('logo4.png')}
                    sx={{
                        height: 0.8,
                        ml: 3,
                    }} />

                <Box sx={{ flex: 1 }} />

                <Box
                    onClick={() => {
                        JSTool.appleTap();
                    }}
                    component={'img'}
                   src={ settingData.isSea ? JSTool.getImgPath('apple_bg2.png') : JSTool.getImgPath('down_apple_pur2.png')}
                    sx={{
                        display: !JSTool.isIOS && 'none',
                        height: 0.9,
                        mr: '100rem'
                    }} />

                <Box
                    onClick={() => {
                        JSTool.googleTap();
                    }}
                    component={'img'}
                    src={settingData.isSea ? JSTool.getImgPath('google_bg2.png') : JSTool.getImgPath('down_google_pur2.png')}
                    sx={{
                        display: JSTool.isIOS && 'none',
                        height: 0.85,
                        mr: '100rem'
                    }} />

                {/* 菜单动画控件 */}
                <Box
                    sx={{
                        mt: rdd.isIPad13 && 3,
                    }}
                    onClick={menuTap}
                    component={'div'}
                    className='btn-nav'>
                    <i className="draw"></i>
                </Box>
                <MobileMenu isDownload={true} />
            </Stack>



            <Stack
                id='home_page_view'
                sx={{
                    width: 1,
                    overflow: 'auto',
                }}>
                <Stack>
                    <Page0 anchorId={'scroll_to0'} isDownload={true} />
                    <Page1 anchorId={'scroll_to1'} isDownload={true} />
                    <Page3 anchorId={'scroll_to3'} isDownload={true} />
                    <Footer isCR={JSTool.isCR()}/>
                </Stack>
            </Stack>


        </Stack>
    );


}